import {
    remortgageCtaWrapper,
    remortgageCopyWrapper,
    ctaFooter,
    mojoLogoStyle,
    partnershipWrapper,
    remortgageCtaSubtitle,
    buttonWrapper,
    bannerImageStyle,
} from './remortgageBanner.css';
import { MojoLogo, ZooplaPeak22767 } from '@zoopla/assets';
import { MyHomeLockup } from '@zoopla/assets';
import { fontGroups } from '@zoopla-eng/zds-components/themes/font-groups';
import { Box } from '@zoopla-eng/zds-components/box';
import { PageSubtitleShort } from '@zoopla-eng/zds-components/headings';
import {
    ButtonLinkRight,
    ButtonWithIconProps,
} from '@zoopla-eng/zds-components/button';
import { ReactElement, useEffect } from 'react';

type ButtonProperties = {
    category: 'primary' | 'secondary';
    text: string;
    icon: ButtonWithIconProps['Icon'];
    url: string;
    targetBlank?: boolean;
};

type RemortgageBannerProps = {
    title?: string;
    subtitle?: string;
    body: ReactElement;
    ctaButton: ButtonProperties;
    bannerImage?: boolean;
    partnership?: boolean;
    onLoadTrackingFn?: () => void;
    onClickTrackingFn?: () => void;
};

const RemortgageBanner = ({
    title,
    subtitle,
    body,
    ctaButton,
    bannerImage = false,
    partnership = false,
    onLoadTrackingFn,
    onClickTrackingFn,
}: RemortgageBannerProps) => {
    useEffect(() => {
        onLoadTrackingFn?.();
    }, [onLoadTrackingFn]);

    return (
        <Box
            className={remortgageCtaWrapper}
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            rowGap="S500"
            bg={partnership ? 'functionalPrepopulated' : 'tagBackgroundHover'}
        >
            <Box
                className={remortgageCopyWrapper}
                display="flex"
                flex={1}
                flexDirection="column"
                justifyContent="space-between"
                py="M200"
                px="S400"
                bpM100={{ px: 'M200', py: 'M100' }}
            >
                <Box display="flex" flexDirection="column" rowGap="S500">
                    <Box display="flex" flexDirection="column" rowGap="S200">
                        {title ? (
                            <PageSubtitleShort>{title}</PageSubtitleShort>
                        ) : (
                            <MyHomeLockup />
                        )}
                        <p
                            className={`${remortgageCtaSubtitle} ${fontGroups.ladle}`}
                        >
                            {subtitle}
                        </p>
                    </Box>

                    {body}
                </Box>

                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    flexDirection="column"
                    pt="M100"
                    className={ctaFooter}
                >
                    <Box className={buttonWrapper}>
                        <ButtonLinkRight
                            href={ctaButton.url}
                            onClick={onClickTrackingFn}
                            category={ctaButton.category}
                            Icon={ctaButton.icon}
                            rel="noreferrer"
                            target={
                                ctaButton.targetBlank ? '_blank' : undefined
                            }
                        >
                            {ctaButton.text}
                        </ButtonLinkRight>
                    </Box>

                    {partnership && (
                        <Box
                            className={partnershipWrapper}
                            display="flex"
                            flexDirection="row"
                            alignItems="center"
                            rowGap="S200"
                        >
                            <p className={fontGroups.fork}>
                                In partnership with
                            </p>
                            <MojoLogo className={mojoLogoStyle} />
                        </Box>
                    )}
                </Box>
            </Box>

            {bannerImage && (
                <img
                    className={bannerImageStyle}
                    src={ZooplaPeak22767}
                    alt=""
                />
            )}
        </Box>
    );
};

export default RemortgageBanner;
